export default "__VITE_ASSET__to3jokXG__"